import type * as L from "leaflet";
import { i18n } from "src/i18n";

export function useSegmentDraw(
  map: L.Map,
  callbacks: {
    onDraw: (drawing: string) => void;
  }
) {
  /**
   * Functions
   */

  function startDrawing() {
    // @ts-ignore: "segmentDraw" is a valid custom lang name but not in SupportLocales type
    map.pm.setLang(
      "segmentDraw" as never,
      {
        tooltips: {
          continueLine: "Click to continue drawing, or double-click to set last point and finish",
          finishLine: "Double-click to set last point and finish",
        },
      },
      i18n.language
    );

    map.pm.enableDraw("Line", {
      snappable: false,
      finishOn: "dblclick",
    });

    map.on("pm:create", (event) => {
      const { layer } = event;

      // @ts-ignore - toGeoJSON exists but typing is incomplete
      const drawnLine = layer.toGeoJSON();

      layer.remove();

      callbacks.onDraw(drawnLine);
    });

    return function cleanup() {
      map.off("pm:create");
      // @ts-ignore: incomplete type
      map.pm.setLang(i18n.language);
    };
  }

  function stopDrawing() {
    map.pm.disableDraw("Line");
    map.off("pm:create");
    // @ts-ignore: incomplete type
    map.pm.setLang(i18n.language);
  }

  return {
    startDrawing,
    stopDrawing,
  };
}
